import { render } from "./RelationAutoloader.vue?vue&type=template&id=569d2260"
import script from "./RelationAutoloader.vue?vue&type=script&lang=js"
export * from "./RelationAutoloader.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__